import gsap from 'gsap'

// UTILITY FUNCTIONS
function $(className) {
    return document.querySelector(`.${className}`)
}
function $$(id) {
    return document.querySelector(`#${id}`)
}

// blend two hex colors together by an amount
// https://stackoverflow.com/questions/6367010/average-2-hex-colors-together-in-javascript/56348573#56348573
function blendColors(colorA, colorB, amount) {
    const [rA, gA, bA] = colorA.match(/\w\w/g).map((c) => parseInt(c, 16));
    const [rB, gB, bB] = colorB.match(/\w\w/g).map((c) => parseInt(c, 16));
    const r = Math.round(rA + (rB - rA) * amount).toString(16).padStart(2, '0');
    const g = Math.round(gA + (gB - gA) * amount).toString(16).padStart(2, '0');
    const b = Math.round(bA + (bB - bA) * amount).toString(16).padStart(2, '0');
    return '#' + r + g + b;
}

// SELECTIONS
//BODY PARTS
const mixerCover = $('mixer-cover')
const mixerSteamInputCover = $('mixer-steam-input-cover')
const mixerRightFlange = $('mixer-right-flange')
const mixerLeftFlange = $('mixer-left-flange')
const emitterBody = $('emitter')

//Arrows
const waterEntryArrow = $('water-entry-arrow')
const waterT = $('water-t')

const exitArrow = $('exit-arrow')
const waterAtElevatedTempT = $('water-at-elevated-temp-t')

const steamArrow = $('steam-arrow')
const steamT = $('steam-t')

// LOOP
const tempControlLoopT = $('temperature-control-loop-t')
const mainElectricLine = $('main-electric-line')
const signalsArray = [
    $('signal-PID_14'),
    $('signal-PID_13'),
    $('signal-PID_12'),
    $('signal-PID_11'),
    $('signal-PID_10'),
    $('signal-PID_9'),
    $('signal-PID_8'),
    $('signal-PID_7'),
    $('signal-PID_6'),
    $('signal-PID_5'),
    $('signal-PID_4'),
    $('signal-PID_3'),
    $('signal-PID_2'),
    $('signal-PID'),
]
const vSignalsArray = [
    $('signal-PID-v_2'),
    $('signal-PID-v'),
]

//VALVES
const upperTriangle = $('upper-triangle')
const lowerTriangle = $('lower-triangle')
const semiCircle = $('semi-circle')
const temperatureValve = $('t-valve')

//MIXING FLOW
const backgroungFlow = $('background-flow')
const backgroundLinearGradient = $('paint0_linear')
const mixingFlowLinesArray = [
    $('b-1'),
    $('b-2'),
    $('b-3'),
    $('middle-0'),
    $('t-1'),
    $('t-2'),
    $('t-3')
]
const linearGradientofFlowLinesArray = [
  $('paint1_linear').lastChild,
  $('paint2_linear').lastChild,
  $('paint3_linear').lastChild,
  $('paint4_linear').lastChild,
  $('paint5_linear').lastChild,
  $('paint6_linear').lastChild,
  $('paint7_linear').lastChild,
]
const initialColor = backgroundLinearGradient.firstChild.getAttributeNode('stop-color').nodeValue
const finalColor = backgroundLinearGradient.lastChild.getAttributeNode('stop-color').nodeValue
console.log(initialColor, finalColor)
// const finalColor = linearGradientofFlowLines[0].nextSibling.getAttributeNode('stop-color').nodeValue

// ANIMATION UTILITY FUNCTIONS
function drawSVG(path, drawingDuration = 2, positionParameter = '', ease = 'power4.out') {
    const l = path.getTotalLength()
    const tl = new gsap.timeline()
    tl.set(path, {strokeDasharray: l}).fromTo(path, {
        strokeDashoffset: l,
        opacity: 0
    }, {
        strokeDashoffset: 0,
        duration: drawingDuration,
        opacity: 1,
        ease: ease
    }, positionParameter);
    return tl
}

function curvedDrawingSVGAndStrokeAnimation(path, duration = 10, strokeDasharray = '4 4', reverse = false) {
    const tl = new gsap.timeline()
    drawSVG(path, reverse)

    if (! reverse) {
        tl.to(path, {
            strokeDasharray: strokeDasharray,
            strokeOpacity: 0.5,
            ease: 'power4.out',
            duration: 0.2
        }, 'dashes+=1').fromTo(path, {
            strokeDashoffset: path.getTotalLength()
        }, {
            strokeDashoffset: 0,
            ease: 'linear',
            repeat: -1,
            duration: duration
        }, '>')

    } else {
        tl.to(path, {
            strokeDasharray: strokeDasharray,
            strokeOpacity: 0.5,
            ease: 'power4.out',
            duration: 0.2
        }, 'dashes+=1').fromTo(path, {
            strokeDashoffset: 0
        }, {
            strokeDashoffset: path.getTotalLength(),
            ease: 'linear',
            repeat: -1,
            duration: duration
        }, '>')
    }

    return tl
}
// https://greensock.com/forums/topic/21618-remove-an-element-at-end-of-tween/
function removeElement(element) {
    if (typeof(element) === "string") {
        element = document.querySelector(element);
    }
    return function () {
        element.parentNode.removeChild(element);
    };
}


// ANIMATIONS
function setThings() {
    const tl = new gsap.timeline()
    tl.set([
        mixerCover,
        mixerSteamInputCover,
        mixerRightFlange,
        mixerLeftFlange,
        waterEntryArrow,
        waterT,
        exitArrow,
        waterAtElevatedTempT,
        steamArrow,
        steamT,
        tempControlLoopT,
        mainElectricLine,
        ...signalsArray,
        ...vSignalsArray,
        upperTriangle,
        lowerTriangle,
        semiCircle,
        temperatureValve,
        backgroungFlow,
        ...mixingFlowLinesArray,
    ], {opacity: 0})
    .set([backgroundLinearGradient.childNodes[2], backgroundLinearGradient.childNodes[3]], {stopColor: initialColor})
    .set(linearGradientofFlowLinesArray, {stopColor: initialColor})
    return tl
}
function entry() {
    const tl = new gsap.timeline
    // tl.fromTo([
    //     mixerLeftFlange,
    //     mixerRightFlange,
    // ], {
    //     opacity: 0,
    //     // x: gsap.utils.wrap([-10, 10]),
    //     ease: 'power3.out',
    // }, {
    //     duration: 2,
    //     opacity: 1,
    //     // x: 0
    // }).fromTo([mixerCover, mixerSteamInputCover], {
    //     opacity: 0,
    //     // y: gsap.utils.wrap([10, -10])
    // }, {
    //     opacity: 1,
    //     y: 0,
    //     stagger: 0.1,
    //     ease: 'power3.out',
    //     duration: 2
    // }, '')
    tl.fromTo([
        mixerLeftFlange,
        mixerRightFlange,
        mixerCover, 
        mixerSteamInputCover,
        emitterBody
    ], {
        opacity: 0,
        y: -10,
    }, {
        opacity: 1,
        duration: 2,
        y: 0,
        ease: 'sine'
    })
    return tl
}
function flowStart() {
    const tl = new gsap.timeline()
    tl.fromTo([waterEntryArrow, waterT], {
        opacity: 0,
        x: gsap.utils.wrap([-15, -10])
    }, {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: 'sine',
        stagger: 0.3
    })
    .fromTo(backgroungFlow, {
        attr:{d: 'M24.28 219.701h0v48.014H24.28z'}
    }, {
        attr:{d: 'M24.28 219.701h906.451v48.014H24.28z'},
        duration: 4,
        opacity: 1,
        ease: 'linear'
    })
    
    return tl
}
function mixingLines() {
    const tl = new gsap.timeline()
    drawSVG(mixingFlowLinesArray[0], 4, '', 'power3.in')
    drawSVG(mixingFlowLinesArray[1], 4.15, '', 'power4.in')
    drawSVG(mixingFlowLinesArray[2], 4.2, '', 'expo.in')
    drawSVG(mixingFlowLinesArray[3], 4.1, '', 'power3.in')
    drawSVG(mixingFlowLinesArray[4], 4, '', 'power4.in')
    drawSVG(mixingFlowLinesArray[5], 4.2, '', 'power4.in')
    drawSVG(mixingFlowLinesArray[6], 4.2, '', 'expo.in')
    .set(mixingFlowLinesArray, {
        strokeDasharray: '2 4',
        ease: 'power4.out',
        duration: 0.1
    })
    .fromTo(mixingFlowLinesArray, {
        strokeDashoffset: mixingFlowLinesArray[0].getTotalLength()
    }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 20
    }, '>')
    return tl
}
function steam(){
    const tl = new gsap.timeline()
    tl.fromTo([steamArrow, steamT], {
        opacity: 0,
        y: gsap.utils.wrap([-15, -10])
    }, {
        opacity: 1,
        y: 0,
        duration: 2,
        ease: 'sine',
        stagger: 0.3,
    })
    // .add( gsap.delayedCall('+=2', doAnimation()))
    .call(
        doAnimation(),
        null,
        "<+=3"
    )
    return tl
}
function changeColor(){
    const tl = new gsap.timeline()
    tl.to(linearGradientofFlowLinesArray, {
        stopColor: finalColor,
        duration: 2
    })
    .to([backgroundLinearGradient.childNodes[2], backgroundLinearGradient.childNodes[3]], {
        stopColor: finalColor,
        duration: 2
    }, '-=1')
    .fromTo([exitArrow, waterAtElevatedTempT], {
        opacity: 0,
        x: gsap.utils.wrap([-15, -10])
    }, {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: 'sine',
        stagger: 0.3
    })
    return tl
}
function controlLoop(){
    const tl = new gsap.timeline()
    drawSVG(mainElectricLine, 2, '')
    tl.fromTo(temperatureValve, {
        opacity: 0,
        y: 5
    }, {
        opacity: 1,
        y: 0
    })
    .fromTo(tempControlLoopT, {
        opacity: 0,
        y: 10
    }, {
        opacity: 1,
        y: 1,
        duration: 2,
        ease: 'sine'
    })
    .addLabel('startSignals')
    .fromTo(vSignalsArray, {
        opacity: 0,
        y: 5
    }, {
        y: 0,
        opacity: 1,
        stagger: 0.1,
        ease: 'sine',
        duration: 0.2
    }, '+0')
    .fromTo(signalsArray, {
        opacity: 0,
        x: 10
    }, {
        x: 0,
        opacity: 1,
        stagger: 0.08,
        ease: 'sine',
        duration: 0.2
    }, '>')

    .fromTo([upperTriangle, lowerTriangle, semiCircle], {
        opacity: 0,
        y: gsap.utils.wrap([-10, 10, 0]),
        x: gsap.utils.wrap([0, 0, -10])
    }, {
        opacity: 1,
        y: gsap.utils.wrap([0, 0, 0]),
        x: gsap.utils.wrap([0, 0, 0]),
        duration: 2,
        ease: 'power4.out'
    }, '-=2')
    return tl
}

const master = new gsap.timeline()
master
.add(setThings)
.add(entry)
.add(flowStart, "+=2")
.add(mixingLines, '+=0')
.add(steam, '+=6')
.add(changeColor, '+=2.5')
.add(controlLoop, "+=4")